<template>
<div>
            <div class="tbl">
                <!--
                <div class="tbl-row">
                    <div class="tbl-col">
                        サービス
                    </div>
                </div>
                -->
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        お名前
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="f_name" class="col-two" placeholder="例) 山田" required=""><input type="text" name="l_name" class="col-two last" placeholder="例) 太郎" required="">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        お名前（ふりがな）
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="f_name_s" class="col-two" placeholder="例) やまだ" required=""><input type="text" name="l_name_s" class="col-two last" placeholder="例) たろう" required="">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        会社名
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="company" placeholder="例) 株式会社ranryu" required="">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        所属部署
                    </div>
                    <div class="tbl-col">
                        <div class="ninfo">任意</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="department">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        役職名
                    </div>
                    <div class="tbl-col">
                        <div class="ninfo">任意</div>
                    </div>
                    <div class="tbl-col">
                        <input type="text" name="position">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        メールアドレス
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="email" name="email" id="email_2" placeholder="例) info@ranryu.co.jp" required>
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        メールアドレス（確認）
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="email" name="email2" id="emailConfirm_2" placeholder="例) info@ranryu.co.jp" required="" onpaste="return false;">
                    </div>
                </div>
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        電話番号
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <input type="tel" name="tel" placeholder="例) 0344053715" required="">
                    </div>
                </div>
                <!-- その他の場合はテキストエリア -->
                <div v-if="$route.params.category1 != 2">
                <hr>
                <div class="tbl-row">
                    <div class="tbl-col">
                        お問い合わせ内容
                    </div>
                    <div class="tbl-col">
                        <div class="hinfo">必須</div>
                    </div>
                    <div class="tbl-col">
                        <textarea rows="10" name="others"></textarea>
                    </div>
                </div>
                </div>
            </div>
            <div class="container" style="display: flex; justify-content: center; align-items: center;height: 100%;width:100%;z-index: 100;position:absolute;left:0;top:0;opacity: 1;background-color: white" v-show="isProcessing">
                <vue-loading type="spin" color="#333" :size="{ width: '50px', height: '50px' }" ></vue-loading>
            </div>
            <div class="form-info"><input type="checkbox" name="privacy_confirm">
                ご提供頂く個人情報のお取り扱いに同意する。<br><br>
                <p style="font-size: 1.5rem; font-weight: normal">個人情報のお取り扱い方針は<a href="/policy.html">こちら</a>をご覧下さい。</p>
                <br>
                <div align="center">
      <vue-recaptcha
        sitekey="6Lc8_dsaAAAAAAcYtHJY90ISLd3zuWRt_FhUzcgE"
        ref="invisibleRecaptcha"
        @verify="verify"
      ></vue-recaptcha>
            </div>
            </div>
            <div class="u-center">
                <input type="button" style="-webkit-appearance: none" value="入力内容の確認へ" class="form-btn" v-on:click="submitConfirm()" v-bind:disabled="isProcessing">
            </div>
</div>
</template>

<script>
import CommonMixin from '@/mixins'
import $ from 'jquery'
import axios from 'axios'
import { VueLoading } from 'vue-loading-template'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'CommonFormInput',
  mixins: [CommonMixin],
  mounted () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
    document.head.appendChild(recaptchaScript)
  },
  data () {
    return {
      errors: [],
      isProcessing: false,
      isReCaptchaVerify: false,
      reCaptchaResponse: ''
    }
  },
  methods: {
    verify (res) {
      this.isReCaptchaVerify = true
      this.reCaptchaResponse = res
    },
    submitContact: function () {
      var postParams = {
        'f_name': {'label': '苗字', 'val': '', 'require': true},
        'l_name': {'label': '名前', 'val': '', 'require': true},
        'f_name_s': {'label': '苗字(ふりがな)', 'val': '', 'require': true},
        'l_name_s': {'label': '名前(ふりがな)', 'val': '', 'require': true},
        'company': {'label': '会社名', 'val': '', 'require': true},
        'department': {'label': '部署', 'val': '', 'require': false},
        'position': {'label': '役職', 'val': '', 'require': false},
        'email': {'label': 'メールアドレス', 'val': '', 'require': true},
        'tel': {'label': '電話番号', 'val': '', 'require': true}
      }
      var regMail = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
      var regTel = /^(0\d{1,3}-\d{1,4}-\d{4}|\d+)$/
      Object.keys(postParams).forEach(function (name) {
        var val = $('input[name="' + name + '"]').val()
        postParams[name].val = val
        if (val === '' && postParams[name].require === true) {
          this.errors.push('[' + postParams[name].label + ']は必須項目です。')
        }
      }, this)
      if ($('input[name="email"]').val() !== $('input[name="email2"]').val()) {
        this.errors.push('[メールアドレス]が一致しません')
      }
      if (!regMail.test($('input[name="email2"]').val())) {
        this.errors.push('[メールアドレス]が不正です')
      }
      if (!regTel.test($('input[name="tel"]').val())) {
        this.errors.push('[電話番号]が不正です')
      }
      postParams.category = []
      postParams.additional = []
      postParams.additionalCheck = []
      if (this.route.params.category1 === '0') {
        this.hpConfig.category3_elment.forEach(function (o) {
          o.forEach(function (elm) {
            if (elm.checked) {
              // TODO 特殊文字を置換する必要がある場合
              postParams.category.push(elm.label.replace(/&#038;/, '&'))
              // FIXME s3に上げるときはここは不要
              // if (this.hpConfig.category_3_element_requires[elm.value] !== undefined) {
              //  elm.require_forms = this.hpConfig.category_3_element_requires[elm.value]
              // }
              if (elm.require_forms !== undefined) {
                // 必須チェック
                elm.require_forms.forEach(function (forms) {
                  var input = $('*[name=' + forms.name + ']')
                  if (postParams['additionalCheck'][forms.name] === true) return
                  postParams['additionalCheck'][forms.name] = true
                  if (input.is('select')) {
                    input = $('*[name=' + forms.name + '] option:selected')
                    postParams['additional'].push({'label': forms.label, 'val': input.text()})
                  } else if (input.is('input')) {
                    postParams['additional'].push({'label': forms.label, 'val': input.val()})
                    if (!input.val()) {
                      this.errors.push('[' + elm.label + ']<br>&nbsp&nbsp => [' + forms.label + ']は必須項目です。')
                    }
                  }
                }, this)
              }
            }
          }, this)
        }, this)
      } else if (this.route.params.category1 === '1') {
        this.hpConfig.category2_business_elment.forEach(function (o) {
          if (o.checked) {
            postParams.category.push(o.label)
          }
        })
      }

      if (this.route.params.category1 !== '2') { // TODO: 3以外の条件分岐になってたけどなんで？
        var othersTxt = $('textarea[name="others"]').val()
        if (!othersTxt) {
          this.errors.push('[お問い合わせ内容]は必須項目です。')
        } else {
          postParams.others = {'label': 'お問い合わせ内容', 'val': othersTxt, 'require': false}
        }
      }

      if (postParams.category.length <= 0 && this.route.params.category1 !== '3') {
        this.errors.push('カテゴリは最低1つ選択して下さい。')
      }
      postParams.subject = this.hpConfig.category2_title[this.route.params.category1] + 'がありました。'
      postParams.reCaptcha = this.reCaptchaResponse
      console.log(postParams)
      // FIXME ローカル時はコメントアウトを削除。
      // this.$dialog.alert(' Test end! ' + this.errors.join('<br>'), {html: true})
      // return;
      if (this.errors.length > 0) {
        this.$dialog.alert('<p style="color: red">入力値を確認してください。</p><br>' + this.errors.join('<br>'), {html: true})
      } else {
        this.postData(postParams)
      }
    },
    async postData (postData) {
      const url = 'https://1s2ukr4ff1.execute-api.ap-northeast-1.amazonaws.com/beta/contact/create'
      const args = {
        data: postData,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }
      await axios.post(url, postData, args.headers).then(x => {
        this.isProcessing = false
        if (x.data.errors !== undefined) {
          this.errors = x.data.errors
          this.$dialog.alert('<p style="color: red">フォーム送信出来ませんでした。</p><br>' + this.errors.join('<br>'), {html: true})
        } else {
          window.location = '/' + process.env.URL_PREFIX + '#/contact_fns/'
        }
      }).catch(err => {
        this.isProcessing = false
        console.log(err)
        alert('フォーム送信出来ませんでした。')
      })
    },
    submitConfirm: function () {
      if (!this.isReCaptchaVerify) {
        this.$dialog.alert('[reCaptcha]にチェックして下さい。')
        // FIXME 本番適用時はちゃんとreturn
        return
      }
      var pc = $('input[name="privacy_confirm"]')
      if (!pc.prop('checked')) {
        this.$dialog.alert('個人情報のお取り扱いについて同意して下さい。')
        return
      }
      this.errors = []
      var _this = this
      _this.isProcessing = true
      this.$dialog.confirm({
        title: '送信確認',
        body: 'フォームを送信しても良いですか？'
      }, {
        okText: 'はい',
        cancelText: 'キャンセル'
      }).then(function () {
        _this.submitContact()
        _this.isProcessing = false
      }).catch(function () {
        _this.isProcessing = false
      })
    }
  },
  created: function () {
    this.route = this.$route
  },
  components: {
    VueLoading,
    'vue-recaptcha': VueRecaptcha
  }
}
</script>

<style scoped>
.tbl-col {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonFormInput.vue